import React, { useEffect, useState } from 'react';

function ConvertLead({ LeadData }) {
  const [leadToDelete, setLeadToDelete] = useState({});

  useEffect(() => {
    if (LeadData) {
      setLeadToDelete(LeadData);
    }
  }, [LeadData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6 className="text-confirm mb-3">
        The following Lead record will be Converted to Client, you can update the other details from Client Module.
      </h6>

      <ul className="list-unstyled">
        <li><strong>Client Name:</strong> {leadToDelete.ClientName || 'N/A'}</li>
        <li><strong>Mobile No:</strong> {leadToDelete.MobileNumber || 'N/A'}</li>
        <li><strong>Email ID:</strong> {leadToDelete.EmailId || 'N/A'}</li>
        <li><strong>Description1:</strong> {leadToDelete.Description || 'N/A'}</li>

        {leadToDelete.ClientCompanyTypeNames && (
          <li><strong>Product Investments:</strong> {leadToDelete.ClientCompanyTypeNames}</li>
        )}
      </ul>

      {/* Hidden field for debugging or submission (if needed) */}
      <div id="DeleteLeadDetails" hidden>
        {JSON.stringify(leadToDelete)}
      </div>
    </div>
  );
}

export default ConvertLead;
